// ADR 17.9.26k §3 / 25.9.26g §4 — a strip's remembered dismissal.
//
// One generic hook, keyed by the caller: the install strip
// (`pwa/InstallStrip.tsx`) is its one reader today. It renders nothing and
// decides no visibility of its own — only "has this browser said no".

import { useState } from 'react'

/**
 * Is the strip dismissed, and the one way to dismiss it.
 *
 * `useCollapsedChrome`'s *shape*, not the hook: that one emits
 * `web_chrome_fold_toggled` with a `ChromeRegion`, and a strip is not a chrome
 * region. A blocked store shows the strip and forgets the dismissal at the
 * next load, which is the tolerable direction; a write that fails still holds
 * for this session. The key is a promise to the learner's browser and
 * survives any rename of the component.
 */
export function useInviteDismissed(key: string): [boolean, () => void] {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.localStorage.getItem(key) === 'true'
    } catch {
      return false
    }
  })
  return [
    dismissed,
    () => {
      setDismissed(true)
      try {
        window.localStorage.setItem(key, 'true')
      } catch {
        // The dismissal still holds for this session.
      }
    },
  ]
}
